import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Heading, Text } from '@frontend/design-system';

interface Props {
  appointmentsInfoText: string;
  providerName: string;
}

export const PanelHeader = ({ appointmentsInfoText, providerName }: Props) => {
  const { t } = useTranslation('schedule');

  return (
    <header css={{ padding: theme.spacing(2, 2, 2, 3) }}>
      <Heading level={2}>{t('Overlapping Appointments')}</Heading>
      <div css={textContainerStyle}>
        <Icon name='calendar-small' color='light' />
        <Text size='medium' color='light'>
          {appointmentsInfoText}
        </Text>
      </div>
      <div css={textContainerStyle}>
        <Icon name='user-small' color='subdued' />
        <Text size='medium' color='subdued'>
          {providerName}
        </Text>
      </div>
    </header>
  );
};

const textContainerStyle = css({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
});
